<markant-dialog
  fullwidth="false"
  critical="false"
  class="dialog-container"
  [open]="true"
  [headTitle]="'dashboardOverview.groupAssignment.createNewGroup' | transloco"
  (close)="closeDialog()"
>
  <span class="sub-title">
    {{ 'dashboardOverview.groupAssignment.createNewGroupSubTitle' | transloco }}
  </span>

  <form class="user-group-form" (submit)="onCreateGroup()">
    <markant-input
      data-cy="input-group-name"
      [formControl]="groupNameInput"
      [label]="'dashboardOverview.groupAssignment.groupName' | transloco"
      [showLabelHint]="true"
      [required]="true"
      [outlined]="true"
      [errorText]="
        groupNameInput.errors
          | formControlKeyError
            : 'error.validation'
            : groupNameInput.touched || groupNameInput.dirty
          | transloco
      "
      [error]="
        groupNameInput.errors
          | formControlError: groupNameInput.touched || groupNameInput.dirty
      "
      [placeholder]="
        'dashboardOverview.groupAssignment.enterGroupName' | transloco
      "
      maxlength="50"
      [helperCharacterCounter]="true"
      class="group-name-input"
    >
    </markant-input>
  </form>

  <div slot="footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="closeDialog()"
    >
      {{ 'dashboardOverview.groupAssignment.cancel' | transloco }}
    </markant-button>

    <markant-button colorScheme="primary" (click)="onCreateGroup()">
      {{ 'dashboardOverview.groupAssignment.next' | transloco }}
    </markant-button>
  </div>
</markant-dialog>
